import {CollectionHeader, WorkingData} from '../../../../../_models/collectionModels'
import {
  DataFormGroupModel,
  DataFormInputModel,
  VisibilityTrigger,
} from '../../../../../_models/dataFormModels'

export const stepDescription = (collectionHeader?: CollectionHeader) => {
  switch (collectionHeader?.step) {
    case 2:
      return 'a waiting'
    case 3:
      return 'an approved'
    case 4:
      return 'a deleted'
    case 5:
      return 'an approved not reported'
    default:
      return ''
  }
}

const compareValues = (formValue: string | null | undefined, triggerValue: string): boolean => {
  if (formValue === triggerValue) return true

  // Handle array values stored as JSON strings
  if (formValue?.startsWith('[') && formValue.endsWith(']')) {
    try {
      const parsedFormValue = JSON.parse(formValue)
      return Array.isArray(parsedFormValue) && parsedFormValue.includes(triggerValue)
    } catch {
      return false
    }
  }

  return false
}

// visibility status does not account for multi input checkboxes
// TODO: support should be added here
export const getVisibilityStatus = (
  formValues: WorkingData[],
  visTriggers: VisibilityTrigger[]
) => {
  const visibilityTriggerItemIDs = new Set(visTriggers.map((trigger) => trigger.itemID))

  const triggerFormItems = formValues.filter((v: WorkingData) =>
    visibilityTriggerItemIDs.has(Number(v.itemID))
  )
  const triggerFieldValue = triggerFormItems.map((v: any) => v.masterInput)
  return visTriggers.some((trigger) => triggerFieldValue.includes(trigger.fieldValue))
}

// also must handle strings like '[1,2,3]' from multiselect
export const validateMasterValue = (val: string | null | undefined) => {
  // undefined / null / empty string are not valid
  if (val == null || val === '') return false

  // non-array-strings are valid
  if (!val.startsWith('[') || !val.endsWith(']')) {
    return true
  }

  try {
    const parsed = JSON.parse(val)
    return Array.isArray(parsed) && parsed.length > 0
  } catch {
    // If parsing fails, treat as regular string value and is valid
    return true
  }
}

export const getVisibleItemIDs = (
  values: WorkingData[],
  groups: DataFormGroupModel[],
  groupVisibilityTriggersByFormObjectId: Map<number, VisibilityTrigger[]>,
  itemVisibilityTriggersByFormObjectId: Map<number, VisibilityTrigger[]>,
  itemsByGroup: Map<number, DataFormInputModel[]>
): Set<number> => {
  const formValues = new Map(values.map((obj) => [Number(obj.itemID), obj.masterInput]))

  const visibleGroups = groups.filter((group) => {
    const groupTriggers = groupVisibilityTriggersByFormObjectId.get(Number(group.groupID))
    if (!groupTriggers) return true

    return groupTriggers.some(({itemID, fieldValue}) => {
      const formValue = formValues.get(Number(itemID)) // can be null / alphanumeric string / stringified array
      return compareValues(formValue, fieldValue)
    })
  })

  const visibleGroupItems = visibleGroups.flatMap(
    (group) => itemsByGroup.get(Number(group.groupID)) ?? []
  )

  const visibleItems = visibleGroupItems.filter((item) => {
    const itemTriggers = itemVisibilityTriggersByFormObjectId.get(Number(item.itemID))
    if (!itemTriggers) return true

    return itemTriggers.some(({itemID, fieldValue}) => {
      const formValue = formValues.get(Number(itemID)) // can be null / alphanumeric string / stringified array
      return compareValues(formValue, fieldValue)
    })
  })

  const visibleItemsSet = new Set(visibleItems.map((item) => Number(item.itemID)))

  return visibleItemsSet
}
